/** Shared look of text inputs. */
export const fieldBase =
  'w-full rounded-field border bg-surface-2 px-3.5 text-[1.0625rem] text-text-1 outline-none transition-colors placeholder:text-text-3 focus:border-text-2';
